import { CONVERSATION_SESSION_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import ObjectDefinitionRecord from '../ObjectDefinitionRecord';
import { ACTIVITY_FILTERS } from '../../permissions/gates';
const ConversationSession = ObjectDefinitionRecord({
  enableAsAssociatedType: true,
  hasAccess: isUngated => isUngated(ACTIVITY_FILTERS),
  objectTypeId: CONVERSATION_SESSION_TYPE_ID,
  referenceObjectType: 'CONVERSATION_SESSION_PROPERTIES'
});
export default ConversationSession;